import { B2bWithdrawalsCreate } from '@sh4res/bo-common/resources/b2b/withdrawals';

import { WithdrawalsList } from '@Resources/withdrawals/WithdrawalsList';
import { WithdrawalsShow } from '@Resources/withdrawals/WithdrawalsShow';
import { ResourceDefinition } from '@Utils/types';

export const withdrawalsResource: ResourceDefinition = {
  options: { label: 'menu.withdrawals' },
  list: WithdrawalsList,
  show: WithdrawalsShow,
  create: B2bWithdrawalsCreate,
};
